import {
    getVertuoNext,
    getOrganicEu,
    getRainforest,
    getLabels,
    getProductHighlight,
    getFairTrade,
    getSustainability,
    isRange,
    getCategoryRegEx,
    RANGE_CATEGORY_NAME,
    getArabica
} from '@kissui/helpers/src/cremaDataHelper'

/**
 * Modifies the structure to make it easier to use in components
 * Applies all the data customization mixing Page builder with HMC data
 * @param {object} plpData : original PLP data
 */
export async function getMergedPLPData(plpData) {
    const { data } = plpData
    if (!data) {
        return []
    }

    const eCommerceData = data.configuration.eCommerceData

    addLabels(eCommerceData)

    addProductAttribute(
        eCommerceData,
        getFairTrade,
        (prod, category) => (prod.fairTrade = category.name)
    )
    addProductAttribute(eCommerceData, getProductHighlight, prod => (prod.highlighted = true))
    addProductAttribute(eCommerceData, getVertuoNext, prod => (prod.onlyVertuoNext = true))
    addProductAttribute(eCommerceData, getOrganicEu, prod => (prod.organicEu = true))
    addProductAttribute(eCommerceData, getRainforest, prod => (prod.rainforest = true))
    addProductAttribute(eCommerceData, getSustainability, prod => (prod.sustainability = true))
    addProductAttribute(eCommerceData, getArabica, prod => (prod.arabica = true))

    addSubSegments(eCommerceData)

    return eCommerceData.categories
}

function addSubSegments(eCommerceData) {
    const { categories, productGroups, products } = eCommerceData
    // should be forEach if nothing returned/assigned
    categories.forEach(category => {
        const hasSegment = category.subCategories.length > 0 && isRange(category)
        if (hasSegment) {
            category.segments = category.subCategories.map(categoryId => {
                const segment = categories.find(subCategory => subCategory.id === categoryId)
                if (segment && isSubsegment(categories, segment)) {
                    segment.products = getProductsData(productGroups, segment.id, products)
                    segment.isSegment = true
                }
                return segment
            })
        }

        category.products = getProductsData(productGroups, category.id, products)
    })
}

export function getProductsData(productGroups, categoryId, products) {
    let result = []
    try {
        const currentCategory = productGroups.find(category => category.categoryId === categoryId)

        if (!currentCategory) {
            return result
        }

        const { productIds } = currentCategory
        return productIds.map(productId => {
            const product = products.find(product => product.id === productId)
            return product
        })
    } catch (e) {
        //generally an anti pattern to only log the error, with no try catch the result would be the same
        console.log(e)
    }

    return result
}

/**
 * adds labels property to products containing each label's category data (JSON parsed description property) assigned to it
 * labels are categories that have the label base category as parent
 * to apply a label on a given product, the label has to contain the product
 * this function has to clean the productGroups as well by removing the label ones
 * @param {category[]} categories
 * @param {productGroup[]} productGroups
 * @param {product[]} products
 */
function addLabels(eCommerceData) {
    const { categories, productGroups, products } = eCommerceData
    const labels = getLabels(categories)
    const labelGroups = getLabelGroups(productGroups, labels)
    labelGroups.forEach(group => {
        const label = labels.find(label => label.id === group.categoryId)
        group.productIds.forEach(productId => {
            const prod = products.find(product => product.id === productId)
            prod.labels = prod.labels || []
            prod.labels.push(label.description)
        })
    })
    //removing label categories from productGroups
    labelGroups.forEach(labelGroup => {
        const indexToRemove = productGroups.findIndex(
            productGroup => productGroup.categoryId === labelGroup.categoryId
        )
        productGroups.splice(indexToRemove, 1)
    })
}

/**
 * adds a property to products containing the given category assigned to it
 * The category is recognized by ID
 * to apply a the category on a given product, the category's productGroup has to contain the product
 * this function has to clean the productGroups as well by removing the given's one to not let it display as a range in the PLP
 * @param {category[]} categories
 * @param {productGroup[]} productGroups
 * @param {product[]} products
 */
function addProductAttribute(eCommerceData, categoryFetcher, assignHandler) {
    const { categories, productGroups, products } = eCommerceData
    const category = categoryFetcher(categories)
    if (!category) {
        return
    }
    const categoryGroup = getCategoryGroup(productGroups, category)
    if (!categoryGroup) {
        return
    }
    categoryGroup.productIds.forEach(productId => {
        const prod = products.find(product => product.id === productId)
        if (categoryFetcher === getArabica) {
            console.log('addProductAttribute', prod)
        }
        assignHandler(prod, category)
    })
    const indexToRemove = productGroups.findIndex(
        productGroup => productGroup.categoryId === categoryGroup.categoryId
    )
    productGroups.splice(indexToRemove, 1)
}

/**
 * retrieve all the productGroup that are labels
 * @param {productGroup[]} productGroups
 * @param {category[]} labels
 */
function getLabelGroups(productGroups, labels) {
    return productGroups.filter(group => labels.some(label => label.id === group.categoryId))
}

/**
 * retrieve the productGroup which correspond to a category
 * @param {productGroup[]} productGroups
 * @param {category} fairTrade
 */
function getCategoryGroup(productGroups, category) {
    return productGroups.find(group => category.id === group.categoryId)
}

/**
 * returns true when the category is child of the range category (is type range)
 * @param {category} category
 */
export function isSubsegment(categories, category) {
    /*category.superCategories.some(superCategoryId => {
        const superCategoryData = categories.find(categoryToFind => categoryToFind.id === superCategoryId)
    })*/
    const result = category.superCategories.some(superCategory =>
        getCategoryRegEx(RANGE_CATEGORY_NAME).test(superCategory)
    )
    return result
}
export function getFinalPrice(show_sleeve_price, product, isBundled) {
    let showCapsulePrice = show_sleeve_price
    let final_price
    let price_per_capsule

    const bundled = isBundled(product)

    if (product.type === 'capsule' && !bundled) {
        final_price = product.price * product.salesMultiple
        // this isn't necessary in prod but the mock price formatter needs it
        final_price = Math.round(final_price * 100) / 100
        price_per_capsule = product.price
    } else {
        showCapsulePrice = false
        final_price = product.price
    }

    return { showCapsulePrice, final_price, price_per_capsule }
}
